module.exports = __webpack_public_path__ + "static/assets/e1458b7d4009bebd1dd5e614404e6380.svg";